import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';
import { KEEPER_DUEL_ACCENT } from '../../../src/quiz/constants/keeperDuel.constants';

export const keeperDuelViewStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0B1220',
  },

  backButton: {
    position: 'absolute',
    top: 8,
    left: 8,
    zIndex: 50,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backArrow: {
    color: '#F7FAFC',
    fontSize: 20,
    fontWeight: '800',
    marginTop: -2,
  },

  // The game canvas fills the full available body.
  canvasWrap: {
    flex: 1,
    overflow: 'hidden',
    backgroundColor: '#0B1220',
  },

  // Overlays cover the canvas for loading / error / run summary.
  overlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    padding: 24,
    backgroundColor: 'rgba(11,18,32,0.85)',
  },
  message: { color: WARMUP_COLORS.textDim, fontSize: 14, fontWeight: '500', textAlign: 'center' },

  retryButton: {
    backgroundColor: KEEPER_DUEL_ACCENT,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 28,
  },
  retryText: { color: WARMUP_COLORS.textOnBright, fontSize: 15, fontWeight: '800' },
  ghostButton: {
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderWidth: 1.5,
    borderColor: WARMUP_COLORS.borderPurple,
  },
  ghostText: { color: WARMUP_COLORS.text, fontSize: 15, fontWeight: '700' },
  pressedDim: { opacity: 0.7 },

  // Run summary card
  summaryCard: {
    backgroundColor: WARMUP_COLORS.card,
    borderRadius: 18,
    borderWidth: 1.5,
    borderColor: KEEPER_DUEL_ACCENT,
    paddingVertical: 22,
    paddingHorizontal: 24,
    gap: 10,
    minWidth: 300,
    maxWidth: 360,
    alignItems: 'center',
  },
  tierEmoji: { fontSize: 44 },
  tierName: { fontSize: 24, fontWeight: '900', color: WARMUP_COLORS.text, textAlign: 'center', letterSpacing: 0.5 },
  tierScore: { fontSize: 15, fontWeight: '600', color: WARMUP_COLORS.textDim },
  coinsLine: { fontSize: 16, fontWeight: '800', color: WARMUP_COLORS.amber },
  bestLine: { fontSize: 13, fontWeight: '800', color: KEEPER_DUEL_ACCENT },
  capNote: { fontSize: 12, fontWeight: '700', color: WARMUP_COLORS.textDim, textAlign: 'center' },
  buttons: { flexDirection: 'row', gap: 12, marginTop: 8, alignItems: 'center' },

  toast: {
    position: 'absolute',
    bottom: 34,
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,0.75)',
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  toastText: { color: WARMUP_COLORS.text, fontSize: 13, fontWeight: '600' },
});
